module.exports = __webpack_public_path__ + "img/JunNishimura_企画書_ページ_10.3293af56.jpg";